(() => {
  'use strict';
  const link = document.querySelector('[data-arch-chat]');
  if (!link) return;
  let ready = false;
  let attempts = 0;
  let timer;
  function connect() {
    if (ready) return;
    if (typeof window.GorgiasChat?.open !== 'function') {
      if (!timer && attempts++ < 40) timer = setTimeout(() => { timer = undefined; connect(); }, 250);
      return;
    }
    if (timer) clearTimeout(timer);
    ready = true;
    // Hide the floating launcher only after the in-flow replacement can open chat.
    document.body.classList.add('arch-chat-ready');
    link.setAttribute('aria-label', 'Open customer care chat');
    window.GorgiasChat.on?.('widget:closed', () => link.focus({ preventScroll: true }));
  }
  window.addEventListener('gorgias-widget-loaded', connect, { once: true });
  if (window.GorgiasChat?.init) Promise.resolve(window.GorgiasChat.init()).then(connect).catch(() => {});
  link.addEventListener('click', event => {
    if (!ready || typeof window.GorgiasChat?.open !== 'function') return;
    event.preventDefault();
    try { window.GorgiasChat.open(); } catch { window.location.assign(link.href); }
  });
})();
